import { useCallback } from 'react';
import { useLifecycles } from 'react-use';
const postAppInfo = ({ data, appName }) => {
    const manifest = window?.__LOADED_MANIFESTS__?.[appName];
    window.postMessage({
        appName: appName,
        data: {
            version: manifest?.meta?.version,
            // Не во всех манифестах есть meta.sha, но в них version === sha либо version === sha-branch
            sha: manifest?.meta?.sha || manifest?.meta?.version?.split('-')[0],
            projectPath: process.env.CI_PROJECT_PATH,
            branch: process.env.CI_COMMIT_REF_NAME,
            isDevelopment: manifest?.chunks?.some((chunk) => chunk.includes('localhost')) ?? false,
            fromApp: true,
            ...data,
        },
        type: 'M2_BRO_APP_INFO',
        action: 'POST',
    });
};
export const usePostAppInfo = ({ data, appName }) => {
    const repostAuthInfo = useCallback((event) => {
        if (event.data.type === 'M2_BRO_APP_INFO' && event.data.action === 'REFETCH') {
            postAppInfo({ data, appName });
        }
    }, [data, appName]);
    useLifecycles(() => {
        postAppInfo({ data, appName });
        window.addEventListener('message', repostAuthInfo);
    }, () => {
        window.removeEventListener('message', repostAuthInfo);
        window.postMessage({
            appName: appName,
            type: 'M2_BRO_APP_INFO',
            action: 'DELETE',
        });
    });
};
